import React, { useState } from "react";
import {
  useNavigate,
  useParams,
} from "react-router-dom";
import { Table, Button } from "reactstrap";
import WorkoutApi from "../Api";

const SetCard = ({ e_id, s_id, type_of_measurement, set_reps, set_weight }) => {
  const navigate = useNavigate();

  const deleteSet = () => {
    WorkoutApi.deleteSets(e_id, s_id).then((res) => console.log(res));
    navigate();
  };

  return (
    <>
      <tr>
        <th scope="row">{type_of_measurement}</th>
        <td>{set_reps}</td>
        <td>{set_weight}</td>
        <Button color="primary" onClick={deleteSet}>
          X
        </Button>
      </tr>
    </>
  );
};

export default SetCard;
